import { inject, Injectable } from '@angular/core';
import { Category, CategoryTree, GenericStreamListForUserSelection } from '../interfaces/responsedata.ts/generic-streams';
import { GenericStreamService } from './generic-stream.service';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {
    dataService = inject(GenericStreamService);
    streams: GenericStreamListForUserSelection[] = [];

    /**
     * @param data as Category[]
     * Returns Tre within the Categories and Packages
     */
    async buildCategorieTree(data: Category[]): Promise<CategoryTree[] | undefined> {
        if (data.length === 0) return undefined;

        let finalTree: CategoryTree[] = [];
        const streams = await this.dataService.getGenericStreams();
        if (streams !== false) this.streams = streams;

        const firstLevel: any[] = data.filter((cat: Category) => !cat.parentId);
        firstLevel.sort((a, b) => a.orderNr - b.orderNr);

        for (const fst of firstLevel) {
            const childs = this.findChildren(fst.id, data);
            fst.streams = this.streams.filter((stream) => stream.categoryId.includes(fst.id)) || [];
            finalTree.push({ id: fst.id, name: fst.name, orderNr: fst.orderNr, children: childs, streams: fst.streams });
        }


        return finalTree;

    }

    /**
    * @param id
    * @param data as Category[]
    * Gets a part of the hole CategoryTree by search Object Id
    *
    */
    findChildren(id: string, data: Category[]): CategoryTree[] {

        const tree: CategoryTree[] = [];
        for (const cat of data) {
            if (cat.parentId === id) {
                const streams = this.streams.filter((stream) => stream.categoryId.includes(cat.id));
                tree.push({ id: cat.id, name: cat.name, orderNr: cat.orderNr, children: [], streams: streams || [] });
            }
        }

        if (tree.length && tree.length > 0) {
            for (const cat of tree) {
                cat.children = this.findChildren(cat.id, data);
                cat.children.sort((a: CategoryTree, b: CategoryTree) => a.orderNr - b.orderNr);
            }
        }
        return tree;
    }

    /**
     *
     * @param id
     * @param tree
     * @returns CategoryTree
     *
     * Returns a Tree of a Vertical, in witch is the StreamId
     */
    flattenChildrenById(id: string, tree: CategoryTree[] = []): CategoryTree[] {
        if (!tree || tree.length === 0) {
            return [];
        }

        const parent = this.findCategoryNode(tree, id);
        if (!parent) {
            return [];
        }

        const flattened: CategoryTree[] = [];
        const collect = (children: CategoryTree[]) => {
            for (const child of children) {
                flattened.push({ id: child.id, name: child.name, orderNr: child.orderNr, children: [], streams: child.streams });
                if (child.children && child.children.length > 0) {
                    collect(child.children);
                }
            }
        };

        collect(parent.children ?? []);
        return flattened;
    }

    /**
     *
     * @param tree
     * @param id
     * @returns CategoryTree | undefined
     *
     * Returns the node in the CategoryTree
     */
    private findCategoryNode(tree: CategoryTree[], id: string): CategoryTree | undefined {
        for (const node of tree) {
            if (node.id === id) {
                return node;
            }
            if (node.children && node.children.length > 0) {
                const found = this.findCategoryNode(node.children, id);
                if (found) {
                    return node;
                }
            }
        }
        return undefined;
    }
}
